import {NbtipsModule} from "./nbtips/nbtips.module";
import {NbtipsComponent} from "./nbtips/nbtips.component";

export { NbinputModule } from './nbinput/nbinput.module';
export { NbinputDateComponent } from './nbinput/nbinput-date.component';
export { NbinputFileComponent } from './nbinput/nbinput-file.component';
export { NbinputFroalaComponent } from './nbinput/nbinput-froala.component';
export { NbinputGalleryComponent } from './nbinput/nbinput-gallery.component';
export { NbinputImageComponent } from './nbinput/nbinput-image.component';
export { NbinputLabelComponent } from './nbinput/nbinput-label.component';
export { NbinputNumberComponent } from './nbinput/nbinput-number.component';
export { NbinputOptionComponent } from './nbinput/nbinput-option.component';
export { NbinputSignComponent } from './nbinput/nbinput-sign.component';
export { NbinputTextComponent } from './nbinput/nbinput-text.component';
export { NbinputRatingComponent } from './nbinput/nbinput-rating.component';
export { SystemAttachment,NbFieldType,NbFile,NbinputConfig } from './nbinput/nbinput.entity';
export { NbMassiveItem } from './nbinput/nbinput-option.component';
export { OptionDef } from './nbinput/nbinput-label.component';




// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/index.ts